import { useEffect } from 'react';
import { ensureListing } from '../../../util/data';
import { createSlug } from '../../../util/urlHelpers';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';

export const useMalformedSlug = ({ history, params, listingId, getListing }) => {
    const { id, slug: propsSlug } = params;

    useEffect(() => {
        const listingDataLoaded = getListing(listingId);

        if (!listingDataLoaded) {
            return;
        }

        const currentListing = ensureListing(listingDataLoaded);

        const slug = createSlug(currentListing);
        const slugMalformed = slug !== propsSlug;

        if (slugMalformed) {
            history.push(
                createResourceLocatorString('ListingPage', routeConfiguration(), { id, slug }, {})
            );
        }
    }, [propsSlug, listingId]);
};
